import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { StrategicImperativesService } from '../../services/strategic-imperatives.service';
import * as StrategicImperativesActions from './strategic-imperatives.actions';

@Injectable()
export class StrategicImperativesEffects {
  private actions$ = inject(Actions);
  private strategicImperativesService = inject(StrategicImperativesService);

  loadStrategicImperatives$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StrategicImperativesActions.loadStrategicImperatives),
      mergeMap(() =>
        this.strategicImperativesService.getStrategicImperatives().pipe(
          map((imperatives) =>
            StrategicImperativesActions.loadStrategicImperativesSuccess({
              imperatives,
            })
          ),
          catchError((error) =>
            of(
              StrategicImperativesActions.loadStrategicImperativesFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  addStrategicImperative$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StrategicImperativesActions.addStrategicImperative),
      switchMap(({ imperative }) =>
        this.strategicImperativesService.createStrategicImperative(imperative).pipe(
          map((newImperative) =>
            StrategicImperativesActions.addStrategicImperativeSuccess({
              imperative: newImperative,
            })
          ),
          catchError((error) =>
            of(
              StrategicImperativesActions.addStrategicImperativeFailure({
                error,
              })
            )
          )
        )
      )
    )
  );

  updateStrategicImperative$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StrategicImperativesActions.updateStrategicImperative),
      switchMap(({ id, changes }) =>
        this.strategicImperativesService.updateStrategicImperative(id, changes).pipe(
          map((updatedImperative) =>
            StrategicImperativesActions.updateStrategicImperativeSuccess({
              imperative: updatedImperative,
            })
          ),
          catchError((error) =>
            of(
              StrategicImperativesActions.updateStrategicImperativeFailure({
                error,
              })
            )
          )
        )
      )
    )
  );
}
